import { getParameterByName } from '@/utils/';
import { createPostponeQuotation } from '@/services';
import { mapActions } from 'vuex';
export default {
    name: 'Postpone',
    data() {
        return {
            loading: true,
            postponeDays: 4
        };
    },
    async created() {
        this.postponeDays = getParameterByName('days') ? getParameterByName('days') : this.postponeDays;
        this.createPostpone();
    },
    methods: {
        ...mapActions('notification', ['showNotification']),
        goToLandingPage() {
            this.$router.push({ name: 'LandingPage' });
        },
        async makePostData() {
            return {
                quotationId: this.$route.params.quotationId,
                postponeDays: this.postponeDays
            };
        },
        async createPostpone() {
            try {
                const data = await this.makePostData();
                await createPostponeQuotation(data);
                this.loading = false;
            } catch (error) {
                this.showNotification({
                    text: 'Houve um erro interno nos nossos servidores, tente novamente.',
                    type: 'error'
                });
            }
        }
    }
};
